import React from 'react'

export default function Title() {
  return (
    <h1>To-Do List</h1>
  )
}
